import { faCircleNotch } from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React from "react";
import styles from "./Spinner.module.scss";

type Props = Omit<FontAwesomeIconProps, "icon">;

export const Spinner: React.VFC<Props> = ({ className, ...rest }) => (
    <FontAwesomeIcon className={classNames(styles.faSpin, className)} icon={faCircleNotch} {...rest} />
);
